import Vue from "vue";

const addExternalLinkPrefix = Vue.filter('AddExternalLinkPrefix', function (externalLink) {
  if (externalLink.search(/^http[s]?:\/\//) === -1) {
    return `http://${externalLink}`;
  }
  return externalLink;
});

export default addExternalLinkPrefix;
